import { cn } from "@/lib/utils";

const STYLES = {
  VERIFIED: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800",
  "COMMUNITY LORE": "bg-zinc-200 text-zinc-700 dark:bg-zinc-700/50 dark:text-zinc-300 border-zinc-300 dark:border-zinc-600",
  SATIRE: "bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300 border-orange-300 dark:border-orange-800",
  UNCONFIRMED: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300 border-amber-300 dark:border-amber-800",
};

export function LabelBadge({ label, className }) {
  if (!label) return null;
  const key = label.toUpperCase();
  const style = STYLES[key] || STYLES["COMMUNITY LORE"];
  return (
    <span
      data-testid={`label-badge-${key.toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center rounded px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider border",
        style,
        className
      )}
    >
      {key}
    </span>
  );
}
